module.exports = __webpack_public_path__ + "images/404.1791450974374.png";